import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Chip, numeric, Text } from '@frontend/design-system';
import { useScheduleRequestModalContext } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/Context/ScheduleRequestModalContext';
import { Card } from './Card';

export const PaymentInfoCard = () => {
  const { t } = useTranslation('scheduleCalendarRequest');
  const { selectedScheduleRequest, isPaymentsEnabled } = useScheduleRequestModalContext();

  if (!isPaymentsEnabled) {
    return null;
  }

  return (
    <Card
      title={
        <>
          <Icon name='payments' /> {t('Payment Info')}
        </>
      }
    >
      <div>
        <Text size='small' color='subdued'>
          Paid
        </Text>
        {!!selectedScheduleRequest?.bookingAmount && !!selectedScheduleRequest?.paymentTransactionId ? (
          <Chip variant='warn' leftElement={<Icon name='dollar-sign-small' />}>
            {numeric(selectedScheduleRequest?.bookingAmount, { decimals: 2 })}
          </Chip>
        ) : (
          <>-</>
        )}
      </div>
    </Card>
  );
};
